<template>
  <div class="fun-area">
    <div v-if="isSearch" class="panel-container">
      <div class="head-container">
        <slot name="search" />
      </div>
    </div>
    <div class="panel-container fun-container">
      <div class="table-container">
        <div v-if="isTableTop" class="table-top">
          <slot name="table-top" />
        </div>
        <div class="tableContainer">
          <slot name="table" />
        </div>
        <slot name="table-bottom" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isSearch: {
      type: Boolean,
      default: true
    },
    isTableTop: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style>

</style>
